export default "__VITE_ASSET__Bde4N8LX__"